import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Tab from './Tab';

class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: this.getActiveTabIndex(),
    };
  }

  getActiveTabIndex() {
    const { children } = this.props;
    let activeTabIndex = 0;

    React.Children.forEach(children, (child, index) => {
      const { active } = child.props;
      if (active) {
        activeTabIndex = index;
      }
    });

    return activeTabIndex;
  }

  handleTabChange(activeTabIndex) {
    this.setState({
      activeTabIndex,
    });
  }

  render() {
    const { children } = this.props;
    const { activeTabIndex } = this.state;

    const tabsButtons = React.Children.map(children, (child, index) => {
      const { title = '', className, onClick = () => {}, ...rest } = child.props;
      const cls = classnames('tabs__nav-button  cr-pv-2 cr-mh-3 cr-text--heading4', {
        'tabs__nav-button--active': activeTabIndex === index,
        'cr-text--dimmed': activeTabIndex !== index,
        className,
      });
      return (
        // eslint-disable-next-line
        <div
          className={cls}
          onClick={event => {
            onClick(event);
            this.handleTabChange(index);
          }}
          {...Object.assign({}, rest, { active: undefined })}
          role="button"
        >
          {title}
        </div>
      );
    });

    const tabsContent = React.Children.map(children, (child, index) =>
      React.cloneElement(child, {
        active: activeTabIndex === index,
      })
    );

    return (
      <div className="cr-flex cr-flex-col cr-width-full">
        <div className="tabs__nav cr-flex cr-flex-row cr-width-full">{tabsButtons}</div>
        <div className="cr-flex cr-flex-row cr-width-full">{tabsContent}</div>
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.node,
};

export default Tabs;
export { Tab };
